import { Component, Input, inject, DestroyRef } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { InstancesService } from 'src/app/services/api/instances.service';
import { ActivatedRoute } from '@angular/router';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { AvailabilityStatus } from 'src/app/models/availability-status';

@Component({
  selector: 'app-environment-settings',
  templateUrl: './environment-settings.component.html',
  styleUrl: './environment-settings.component.scss',
  standalone: false
})
export class EnvironmentSettingsComponent {
  private destroyRef = inject(DestroyRef);
  @Input() data: any;

  type: any;
  instanceId: any;
  act: any;
  DeployStatus = DeployStatus;
  logConfigUserGuide: string;
  isInprogress: boolean;
  AvailabilityStatus = AvailabilityStatus;

  readonly INITIAL_STATES = [
    DeployStatus.INITIALIZED,
    DeployStatus.INITIALIZE_FAILED,
    DeployStatus.INITIALIZING
  ];

    readonly INSTANCE_DEPLOYING_STATUS = [DeployStatus.DEPLOYING, DeployStatus.TERMINATED,
    DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.TERMINATION_FAILED,
    DeployStatus.INITIALIZED, DeployStatus.INITIALIZE_FAILED, DeployStatus.INITIALIZING];

  constructor(private dialog: MatDialog, private instanceService: InstancesService, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.instanceId = this.route.snapshot.params.instanceId;
    this.instanceService.getInstanceById(this.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
        const logLevel = data.parameters?.logLevel || 'INFO';
        this.isInprogress = this.INSTANCE_DEPLOYING_STATUS.includes(data.status);
        this.type = [
          {label: translate('INSTANCE_LIST.INFO'), selected: logLevel === 'INFO', disabled: this.isInprogress, message: translate('INSTANCE_LIST.INFO_MESSAGE')},
          {label: translate('INSTANCE_LIST.DEBUG'), selected: logLevel === 'DEBUG', disabled: this.isInprogress,message: translate('INSTANCE_LIST.DEBUG_MESSAGE')},
        ];
        }
      });
     
    this.logConfigUserGuide = `${window.location.protocol}//${window.location.hostname}/userguide/docs/tenant-view/configure-the-environments/log-level-configuration`;
  }

  selectOptionsType(item?: any): void {
  this.dialog.open(ConfirmationDialogComponent, {
          panelClass: 'default-dialog-wrapper',
          width: '566px',
          autoFocus: false,
          data: {
            title: translate('INSTANCE_DETAILS.SETTINGS_TITLE'),
            message:`${translate('INSTANCE_DETAILS.SETTINGS_MESSAGE')} "${item.label.toUpperCase()}"`,
            confirmButtonText: translate('DIALOG.CONFIRM')
          }
        })
          .afterClosed()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(confirm => {
            if (confirm) {
              if(this.type) {
              for (const items of this.type) {
                if (items.selected) {
                  items.selected = false;
                }
              }
            }
            if(item) {
            item.selected = !item.selected;
            };

            let data: any = {
              id : this.instanceId,
              parameters: {
                logLevel: item.label.toUpperCase()
              }
          };
          this.onLogDataChange(data);
          }
  })
}

onLogDataChange(data): void {
  this.instanceService.sendingLogBasedOnSelection(data);
}
}
